import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { SELLER_ADJUSTMENT_TYPES_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const sellerAdjustmentTypesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.GET_TYPES:
        return payload || initialState;

      case SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.CREATE_TYPE:
      case SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.EDIT_TYPE:
        draft[payload.sellerAdjustmentTypeId] = payload;
        break;

      case SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.DELETE_TYPE:
        delete draft[meta.sellerAdjustmentTypeId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default sellerAdjustmentTypesReducer;
